import { Icon } from '@iconify/react';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import { useUser, useFirestore, useFirestoreCollectionData, useFunctions } from 'reactfire';
import { collection } from 'firebase/firestore';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
    theme.palette.info.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const TOTAL = 1352831;

export default function AppNewUsers() {
  const { data: user } = useUser();
  const firestore = useFirestore();
  const path = `users/${user.uid}/collections`;
  const ref = collection(firestore, path);
  const { status, data } = useFirestoreCollectionData(ref);

  const numCollections = data ? data.length : 0;
  return (
    <RootStyle>
      <IconWrapperStyle>
        <CollectionsBookmarkIcon />
      </IconWrapperStyle>
      <Typography variant="h3">{numCollections}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Tracked Collections
      </Typography>
    </RootStyle>
  );
}
